var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"logout-page"}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"align":"center"}},[_c('v-progress-circular',{attrs:{"size":60,"width":4,"color":"primary","indeterminate":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }